// extracted by mini-css-extract-plugin
module.exports = {"vipCardContent":"Pricing_vipCardContent____gW_"};